// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_CancelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/cancel/{id}
 *
 * Returns the order id and its new status after cancellation.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_CancelResponseDados {
order_id: number
status: string
}

export type Orders_CancelResponse = ApiResponse<Orders_CancelResponseDados>;

registerResponseContract('Orders_CancelResponse', {
  order_id: { type: 'number',  required: true },
  status:   { type: 'string',  required: true },
})
